<template>
    <div class="animated fadeIn">     
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                    <strong>Assign PDA Module Access</strong>
                    </div>
                    <b-row>
                        <b-col md="12" class="my-1" style="text-align: center; color:#20a8d8;">
            
                        <h4>Please Select PDA Module Assign Access</h4>
                        </b-col>
                    </b-row>
                    <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                        <b-row>
                            <b-col md="5" class="my-1">
                                <ul>
                                    <li>
                                        <label><input type="checkbox" @click='checkAll()' v-model='isCheckAll'> Select All</label>
                                        <ul>
                                            <li v-for="(menus, index_main) in data">
                                                <label>
                                                    <input type="checkbox" v-bind:value='menus' v-model='menusarr' @change='updateParent($event)'> {{menus.title}}
                                                </label>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-col>

                            <b-col md="7" class="text-right">
                                <span class="btn btn-primary" title="Reset Access" @click="resetAccess()" >Reset</span> &nbsp;
                                <span class="btn btn-danger" title="Clear Access" @click="clearAccess()" >Clear</span>
                            </b-col>

                            <b-row style="float:left;">
                                <b-col md="12" class="my-1">
                                    <button class="btn btn-lg btn-primary"  type="submit"  >Save</button>
                                </b-col>
                            </b-row>
                        </b-row>
                    </b-form>

                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// # pdaMenuAccessListing
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'

export default {
    name: 'access', 
    data() {
        return {
            route_id:'',
            id:'',
            userType:'',
            isCheckAll: false,
            data: [],
            UserAllocateData: [],
            data2: ['dashboard_adv','trip_history'],
            customer:{},

            //
            ALLDataArray:[],
            menusarr: [],
            allocatedMenu :[],
            UserAllocateData:[],
            isAssignMatch:false,
            checkRadio:[],
            isReadOnly: false, 
            toname : null,
            fromname : null,
            prevRoute: null,
            fromRoute : null,
            toroute:'',
            fromroute:'',
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

        this.route_id=this.$route.params.id;

        const myArr = this.route_id.split(" ");

        this.id = myArr[0];

        this.userType = myArr[1];

        this.displaydata();
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = to;
            vm.toname = vm.prevRoute.name;
            
            vm.fromRoute = from;
            vm.fromname = vm.fromRoute.name;

            vm.redirectToExit(vm.toname,vm.fromname);
        })    
    },

    methods: {
        redirectToExit(to,from){
            this.toroute = to;
            this.fromroute = from;
        },

        resetAccess(){
            this.menusarr=[];
            this.isCheckAll=false;
            this.displaydata();
        },

        clearAccess(){
            this.menusarr=[];
            this.isCheckAll=false;
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {    
                this.updateaccess();
                }
            });
        },

        displaydata: function () {
            this.menusarr=[];

            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            let obj = {
                sysusermasterid:this.id,
                usertype:this.userType=='3'?'3':this.userType=='4'?'3':this.userType,
            }
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/pdaMenuAccessListing`,obj)
            .then((result) => {
                if (result.body.returnmsg === 'Successful') {
                    this.data  = result.body.returnvalue[0].pdabody;
    
                    var allocatedata=[];
                    this.UserAllocateData=result.body.user_aceess_listing[0].pdabody;
                    allocatedata=result.body.user_aceess_listing[0].pdabody;
       
                    if(this.data.length==allocatedata.length){
                        this.isCheckAll=true;
                    }


                    for (var key in allocatedata) {
                        this.menusarr.push(allocatedata[key]);
                
                    } 
                    console.log(",this.menusarr",this.menusarr)
        
                } 
                else {
                    this.data=[];
                }
            })
            .catch((ex) => {
                console.log('error-----', ex)
            })
        },


        // Function for Check All
        checkAll: function(){
            this.isCheckAll = !this.isCheckAll;

            this.menusarr = [];
        

            if(this.isCheckAll){ 
                var allocatedata=[];
                allocatedata=this.data;
            
                for (var key in allocatedata) {
                
                    this.menusarr.push(allocatedata[key]);
                    
                }
            
            }else{
                this.menusarr = [];
                
                
            }
        },

        updateParent:function(event){
      
            if(event.target.checked==true){
                if(this.data.length==this.menusarr.length){
                    this.isCheckAll=true;
                }

            }
            else{
                this.isCheckAll=false;
            }
        },

        updateaccess: function () {
            this.isAssignMatch=false;
            let userData = localStorage.getItem('userData');
            let userInfo = JSON.parse(userData);

            if(this.menusarr.length){
                // return false
                let obj = {
                    sysusermasterid:this.id ,
                    pdamenubody: this.menusarr,

                }

                // return false;
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updatePDAMenuAccess`,obj)
                    .then((result) => {
                    if (result.body.returnmsg === 'Successful') {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "success",
                            timer: 30000
                            });
                            if (this.fromroute==='coordinator_user') {
                                this.$router.push('/coordinator_user');
                            }
                            else{
                                this.$router.push('/adminuser_mr');
                            }
                        
                    } else {
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000
                            });
                    
                    }
                }).catch((ex) => {
                    console.log('error-----', ex)
                })
            }else{
                this.$fire({
                    text: "Please Select PDA Module Assign Access",
                    type: "warning",
                    timer: 30000
                });
            }
        },
    },
 
}
</script>


